import { Component } from '@angular/core'
import { ArrayWidget } from 'ngx-schema-form'

@Component({
  selector: 'app-array-widget',
  templateUrl: './array-widget.component.html',
  styleUrls: ['./array-widget.component.scss'],
})
export class ArrayWidgetComponent extends ArrayWidget {}
